import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import classNames from 'classnames/bind';
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import noop from 'lodash/noop';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import * as SignInSliderActions from '../../actions/SignInSliderActions';
import User from '../../helpers/User/User';
import AnalyticsAction from '../../actions/AnalyticsAction';
import { selectRewardsRedesignThrottleFF } from '../../selectors/RewardsRedesignSelector';

import NavItem from './sub-components/NavItem';

import * as styles from './CAMNav.css';

const cx = classNames.bind(styles);
const DEFAULT_KEY_NAME = 'default-key';

export class CAMNavWrapper extends PureComponent {
    static propTypes = {
        navConfig: PropTypes.shape({
            guestList: PropTypes.array,
            loggedInList: PropTypes.array,
            indexUrl: PropTypes.string,
        }).isRequired,
        location: PropTypes.shape({
            pathname: PropTypes.string,
            query: PropTypes.oneOfType([PropTypes.object]),
            search: PropTypes.string,
        }).isRequired,
        classes: PropTypes.shape({
            navContainer: PropTypes.string,
            hoverContainer: PropTypes.string,
        }),
        actions: PropTypes.objectOf(PropTypes.func).isRequired,
        history: PropTypes.objectOf(PropTypes.func),
        callBackProps: PropTypes.objectOf(PropTypes.func),
        navListCallBack: PropTypes.func,
        authenticationSuccess: PropTypes.bool,
        reqHeaders: PropTypes.oneOfType([
            PropTypes.object,
        ]) /* eslint react/no-unused-prop-types: 0 */,
        userState: PropTypes.string,
        router: PropTypes.objectOf(PropTypes.func).isRequired,
        highlightActiveItem: PropTypes.bool,
        analyticsActions: PropTypes.objectOf(PropTypes.func).isRequired,
        rewardsSpend: PropTypes.number,
        isFromSignInSlider: PropTypes.bool,
    };

    static defaultProps = {
        navConfig: {
            guestList: [],
            loggedInList: [],
            indexUrl: '',
        },
        location: {
            pathname: '',
            query: {},
            search: '',
        },
        classes: {
            navContainer: '',
            hoverContainer: '',
        },
        history: null,
        callBackProps: null,
        navListCallBack: noop,
        authenticationSuccess: false,
        reqHeaders: {},
        userState: '',
        router: {
            isActive: noop,
        },
        highlightActiveItem: true,
        rewardsSpend: 0,
        isFromSignInSlider: false,
    };

    // this is better when its not recommended to hack for coverage
    /* istanbul ignore next */
    constructor(props) {
        super(props);
        const { isFromSignInSlider } = props;
        // Observering flicker
        // as always getting guestlist rendered from SSR
        // TODO: need to recheck
        let isLoggedIn = false;
        if (!__SERVER__) {
            isLoggedIn = User.isUserLoggedIn(isFromSignInSlider);
        } else {
            const userStateAtServer = get(props, 'reqHeaders.cookies.DP_USER_STATE', '0');
            isLoggedIn = isFromSignInSlider ? userStateAtServer === '1' : userStateAtServer !== '0';
        }

        const isRewardsEnrolled = User.isRewardsEnrolled && User.isRewardsEnrolled();
        this.state = {
            isLoggedIn,
            isRewardsEnrolled,
        };
    }

    componentWillReceiveProps(nextProps) {
        const { isFromSignInSlider } = this.props;
        if (
            nextProps.authenticationSuccess &&
            nextProps.authenticationSuccess !== this.props.authenticationSuccess
        ) {
            this.setState({ isLoggedIn: true });
        }
        /* This is to handle the user state for CAM Nav in CAM Dashboard */
        if (nextProps.userState === '0') {
            this.setState({ isLoggedIn: false });
        } else if (nextProps.userState && nextProps.userState !== '0') {
            this.setState({ isLoggedIn: true });
        }
        if (isFromSignInSlider && nextProps.userState) {
            this.setState({ isLoggedIn: nextProps.userState === '1' });
        }
    }

    getUUID = (navData, key = 0) => {
        if (!navData) return DEFAULT_KEY_NAME;
        const { title = '' } = navData;
        if (!navData?.title && !key && key !== 0) return DEFAULT_KEY_NAME;
        return `${key}-${title?.trim()?.replace(/\s+/g, '-')}`;
    };

    render() {
        const {
            navConfig,
            location,
            actions,
            callBackProps,
            history,
            classes,
            highlightActiveItem,
            analyticsActions,
            navListCallBack,
            rewardsSpend,
            isFromSignInSlider,
        } = this.props;
        const {
            featureFlags: { enableSignInSlider = false, isHideAccountMenuSlider = false } = {},
        } = this.props;
        const { isLoggedIn, isRewardsEnrolled } = this.state;
        const navList = isLoggedIn ? navConfig.loggedInList : navConfig.guestList;

        if (isEmpty(navList)) return null;
        return (
            <div className={cx(classes.navContainer, classes.hoverContainer)}>
                <div
                    data-automation-id="camNavList"
                    className={`${cx('nav-container')} ${dt(['bg-white'])}`}
                >
                    <ul className={cx('parent-list')}>
                        {navList.map((navData, key) => (
                            <NavItem
                                navData={navData}
                                location={location}
                                actions={actions}
                                enableSignInSlider={enableSignInSlider}
                                callBackProps={callBackProps}
                                history={history}
                                key={this.getUUID(navData, key)}
                                isRewardsEnrolled={isRewardsEnrolled}
                                classes={classes.navContainer}
                                highlightActiveItem={highlightActiveItem}
                                analyticsActions={analyticsActions}
                                navListCallBack={navListCallBack}
                                rewardsSpend={rewardsSpend}
                                isHideAccountMenuSlider={isHideAccountMenuSlider}
                            />
                        ))}
                    </ul>
                </div>
            </div>
        );
    }
}
/* istanbul ignore next */
const mapStateToProps = (state, { navConfig }) => ({
    navConfig:
        navConfig ||
        (selectRewardsRedesignThrottleFF(state)
            ? get(state, 'context.preferences.camNav', {})
            : get(state, 'context.preferences.camNavLegacy', {})),
    reqHeaders: get(state, 'context.headers', {}),
    featureFlags: get(state, 'context.featureFlags', {}),
    userState: get(state.accounts, 'userProfile.userState', ''),
});

/* istanbul ignore next */
const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(SignInSliderActions, dispatch),
    analyticsActions: bindActionCreators(AnalyticsAction, dispatch),
});

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(CAMNavWrapper);
